export default {
  // 发送api请求的域名(必须是域名)
  host: process.env.VUE_APP_HOST,
  // api的路径
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // 需要放置在服务器的静态资源地址
  sourceURL: process.env.VUE_APP_SOURCE_URL,
  title: process.env.VUE_APP_TITLE,
  yourConfig: null
}
